<header id="page-topbar">
  <div class="layout-width">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box horizontal-logo">
          <a href="javascript:void(0);" class="logo logo-dark">
            <span class="logo-sm">
              <img src="assets/images/logo/logo-sm-dark.png" alt="" height="22">
            </span>
            <span class="logo-lg">
              <img src="assets/images/logo/logo-dark-wide.png" alt="" height="70">
            </span>
          </a>
          <a href="javascript:void(0);" class="logo logo-light">
            <span class="logo-sm">
              <img src="assets/images/logo/logo-sm-light.png" alt="" height="22">
            </span>
            <span class="logo-lg">
              <img src="assets/images/logo/logo-light-wide.png" alt="" height="70">
            </span>
          </a>
        </div>
        <button type="button" class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none" id="topnav-hamburger-icon" (click)="toggleMobileMenu($event)">
          <span class="hamburger-icon">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </div>
      <div class="d-flex align-items-center">
        <div class="dropdown d-md-none topbar-head-dropdown header-item" ngbDropdown>
          <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none" id="page-header-search-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
            <i class="bx bx-search fs-22"></i>
          </button>
        </div>
        <div class="dropdown ms-1 topbar-head-dropdown header-item" ngbDropdown>
          <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
            @if (flagvalue !== undefined) {
              <img src="{{flagvalue}}" alt="Header Language" height="20" class="rounded">
            }
            @if (flagvalue === undefined) {
              <img src="{{valueset}}" alt="Header Language" height="20" class="rounded">
            }
          </button>
          <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
            <!-- item-->
            @for (item of listLang; track item) {
              <a href="javascript:void(0);" class="dropdown-item notify-item language py-2" data-lang="eng" [ngClass]="{'active': cookieValue === item.lang, 'disabled': item.lang === 'he'}">
                <img src="{{item.flag}}" alt="user-image" class="me-2 rounded" height="18">
                <span class="align-middle">{{item.text}}</span>
              </a>
            }
          </div>
        </div>
        <div class="ms-1 header-item d-none d-sm-flex">
          <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none" data-toggle="fullscreen" (click)="fullscreen()">
            <i class='bx bx-fullscreen fs-22'></i>
          </button>
        </div>
        <div class="ms-1 header-item d-none d-sm-flex">
          <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode shadow-none">
            <i class='bx bx-moon fs-22' role="none" (click)="changeMode('dark')"></i>
            <i class='bx bx-sun fs-22' role="none" (click)="changeMode('light')"></i>
          </button>
        </div>
        <div class="dropdown header-item" ngbDropdown>
          <button type="button" class="btn shadow-none" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
            <span class="d-flex align-items-center">
              <i class="ri-account-circle-fill empty-avatar-icon"></i>
              <span class="text-start">
                <span class="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                  {{ userData?.person?.first_name }} {{ userData?.person?.last_name }}
                </span>
                <span class="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                  {{ 'ROLES.' + userRole | translate: { Default: userRole} }}
                  @if (userRole !== 'ANALYST') {
                    <i class="ri-information-fill align-bottom text-info" role="none" (click)="openTipsModal($event, contentTips)"></i>
                  }
                </span>
              </span>
            </span>
          </button>
          <div class="dropdown-menu dropdown-menu-end dropdown-menu-header" ngbDropdownMenu>
            <a type="button" class="dropdown-item" role="none" (click)="openChangePasswordModal()">
              <i class="ri-lock-password-line text-muted fs-18 align-middle me-2"></i>
              <span class="align-middle">Change Password</span>
            </a>
            @if (userData.clients.length > 1) {
              <a class="dropdown-item pointer" role="none" (click)="changeCompany()">
                <i class="ri-switch-line text-muted fs-18 align-middle me-2"></i>
                <span class="align-middle">Switch Client</span>
              </a>
            }
            @if (userData.clients.length === 1 && userRole !== 'ADMIN') {
              <a class="dropdown-item pointer" role="none" (click)="openCreateNewClient()">
                <i class="ri-add-box-line text-muted fs-18 align-middle me-2"></i>
                <span class="align-middle">Register Client</span>
              </a>
            }
            <!-- <a *ngIf="userRole === 'ADMIN'" role="none" (click)="openCloseAccountModal()" class="dropdown-item pointer">
            <i class="ri-close-circle-line text-muted fs-18 align-middle me-2"></i>
            <span class="align-middle">Close Account</span>
          </a> -->
          <a (click)="logout()" role="none" class="dropdown-item pointer">
            <i class="ri-logout-box-r-line text-muted fs-18 align-middle me-2"></i>
            <span class="align-middle">Logout</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
</header>

<ng-template #changePasswordModal let-modal>
  <div class="modal-content">
    <div class="modal-header p-3">
      <h4 class="mb-0">Change password</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="passresetForm" (ngSubmit)="changePassword()">
        <div class="mb-3">
          <label class="form-label" for="password-input">Current Password <span class="text-danger">*</span></label>
          <div class="position-relative auth-pass-inputgroup">
            <input [type]="currentField ? 'text' : 'password'" class="form-control pe-5 password-input bg-img-none" placeholder="Enter current password" id="current-password-input" aria-describedby="currentpasswordInput" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" required formControlName="current_password" [ngClass]="{ 'is-invalid': submitted && f['current_password'].errors }">
            <button class="btn btn-link position-absolute end-0 top-0 text-decoration-none shadow-none text-muted password-addon" type="button" id="current-password-addon">
              <i class="ri-eye-fill align-middle" [ngClass]="{'mdi-eye-off-outline': !currentField, 'mdi-eye-outline': currentField}" role="none" (click)="togglecurrentField()"></i>
            </button>
            @if (submitted && f['password'].errors) {
              <div class="invalid-feedback">
                @if (f['password'].errors['required']) {
                  <span>Current password is required</span>
                }
              </div>
            }
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label" for="password-input">New Password <span class="text-danger">*</span></label>
          <div class="position-relative auth-pass-inputgroup">
            <input [type]="passwordField ? 'text' : 'password'" class="form-control pe-5 password-input bg-img-none" placeholder="Enter new password" id="password-input" aria-describedby="passwordInput" required formControlName="password" [ngClass]="{ 'is-invalid': submitted && f['password'].errors }" [ngbTooltip]="passwordValidatorTemplate">
            <button class="btn btn-link position-absolute end-0 top-0 text-decoration-none shadow-none text-muted password-addon" type="button" id="password-addon">
              <i class="ri-eye-fill align-middle" [ngClass]="{'mdi-eye-off-outline': !passwordField, 'mdi-eye-outline': passwordField}" role="none" (click)="togglepasswordField()"></i>
            </button>
            @if (submitted && f['password'].errors?.['required']) {
              <div class="invalid-feedback">Please enter password</div>
            }
            @if (submitted && f['password'].errors?.['pattern']) {
              <div class="invalid-feedback">Password must meet the pattern requirements.</div>
            }
            <ng-template #passwordValidatorTemplate>
              <app-password-validator [passwordControl]="f['password']"></app-password-validator>
            </ng-template>
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label" for="confirm-password-input">Confirm New Password <span class="text-danger">*</span></label>
          <div class="position-relative auth-pass-inputgroup mb-3">
            <input [type]="confirmField ? 'text' : 'password'" class="form-control pe-5 password-input bg-img-none" placeholder="Confirm password" id="confirm-password-input" required formControlName="cpassword" [ngClass]="{ 'is-invalid': (submitted && f['cpassword'].errors) || (submitted && passNotTheSame) }">
            <button class="btn btn-link position-absolute end-0 top-0 text-decoration-none shadow-none text-muted password-addon" type="button" id="confirm-password-addon">
              <i class="ri-eye-fill align-middle" [ngClass]="{'mdi-eye-off-outline': !passwordField, 'mdi-eye-outline': passwordField}" role="none" (click)="toggleconfirmField()"></i>
            </button>
            @if (submitted) {
              <div class="invalid-feedback">
                @if (f['cpassword'].errors && f['cpassword'].errors['required']) {
                  <span>Confirm New Password is required</span>
                }
                @if (passNotTheSame && !f['cpassword'].errors) {
                  <span>Passwords are not the same</span>
                }
              </div>
            }
          </div>
        </div>
        <div class="text-end">
          <button type="submit" class="btn btn-primary btn-load">
            <span class="d-flex justify-content-center">
              @if (submitted && spinner) {
                <span class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              }
              <span [ngClass]="submitted && spinner ? 'ms-2' : ''"> Change password </span>
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #successModal let-modal>
  <div class="modal-content">
    <div class="modal-body text-center p-5">
      <div class="text-end">
        <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="mt-2">
        @if (success) {
          <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
        }
        @if (!success) {
          <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
        }
        <h4 class="mb-3 mt-4">{{ success ? 'Password changed Success.' : 'Password changed Error!'}}</h4>
        <p class="text-muted mx-4 mb-0">{{ message }}</p>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #closeAccountModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <div class="mt-2 text-center">
        <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
        <div class="alert alert-danger">
          <p class="mb-0 text-uppercase">Once done, this action cannot be undone!!!</p>
        </div>
        <div class="mt-4 pt-2 fs-18">
          <p class="mb-0 text-uppercase" style="font-weight: bold;">Are you Sure You want to close this account?</p>
        </div>
        <p class="fs-12 text-warning mt-4 mb-0">** You will be logged out immediately after you close your account and you will not be able to sign in again!</p>
      </div>
      <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
        <button type="button" class="btn w-sm btn-light text-uppercase" data-bs-dismiss="modal" (click)="modal.close('Close click')">No, I do not want to close it</button>
        <button type="button" class="btn w-sm btn-danger text-uppercase" id="delete-product" (click)="closeAccount()">Yes, I am sure close it!</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #contentTips let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"> </button>
    </div>
    @if (userRole === 'ADMIN') {
      <div class="modal-body">
        <h5 class="pb-3">Customer top-level role in the platform, ownership to create more roles that use the platform.</h5>
        <h5 class="fs-15">It can do the followings:</h5>
        <ul class="list-group">
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Create a master account.</li>
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Create users and assigned them to the predefined roles.</li>
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Delete users and unassigned users from roles.</li>
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Can delete and close the account <b>(the account must be empty from projects so it can be deleted)</b>.</li>
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Able to create organization structure and set owners into each structure that can create projects.</li>
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Can suspend all roles and projects.</li>
        </ul>
      </div>
    }
    @if (userRole === 'OWNER') {
      <div class="modal-body">
        <h5 class="pb-3">The Project Owner is the higher level of operation, he can create as many projects as he likes within his domain/department and create sub-project in an existing project.</h5>
        <h5 class="fs-15">Project Owner tasks:</h5>
        <ul class="list-group">
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Create a project.</li>
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Delete a project.</li>
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Assign personas into a project (also from another project) and set roles to it.</li>
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Removes personas from a project.</li>
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Can set project expiration date and time.</li>
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Can set temporary personas to a project.</li>
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Can set roles and assign users to them. The new roles are limited only to the specific project they are assigned to.</li>
        </ul>
      </div>
    }
    @if (userRole === 'EDITOR') {
      <div class="modal-body">
        <h5 class="pb-3">The Editor role is the one that can edit a project.</h5>
        <h5 class="fs-15">The Editor can do the followings:</h5>
        <ul class="list-group">
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Edit a project.</li>
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Create questions in the project when using a questionnaire.</li>
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Can edit questionnaire.</li>
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Can delete questionnaire.</li>
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Can invite users/candidates to a questioner.</li>
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Can remove users/candidates from the questionnaire.</li>
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Can set questionnaire or project time limit.</li>
          <li class="list-group-item border-0 p-1"><i class="mdi mdi-check-bold align-middle lh-1 me-2"></i>Can set a expiration time for invitation.</li>
        </ul>
      </div>
    }
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">Close</button>
    </div>
  </div>
</ng-template>

<app-create-new-client #createNewClient (closeSubmittion)="closeSubmittion($event)"></app-create-new-client>